import React from "react";
import { EllipsisVertical } from "lucide-react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Tooltip,
} from "@heroui/react";

const CommonDropdownMenu = ({
  actions = [],
  itemId = null,
  iconSize = 20,
  className = "",
  triggerBtn = null,
  placement = "bottom-end",
  ariaLabel = "More Actions",
  isDisabled = false,
}) => {
  return (
    <Dropdown
      placement={placement}
      isDisabled={isDisabled}
      className={`mt-1 rounded-lg border-[0.5px] border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm ${className || "min-w-[123px]"}`}
      style={{
        zIndex: 1000000000,
      }}
    >
      <DropdownTrigger>
        {triggerBtn ? (
          triggerBtn
        ) : (
          <div>
            <Tooltip
              className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 font-medium text-xs shadow-md border border-gray-100 dark:border-gray-700 px-3 py-1.5 rounded-lg"
              content="More Actions"
            >
              <EllipsisVertical
                className="text-gray-500 dark:text-gray-400 cursor-pointer"
                size={iconSize}
              />
            </Tooltip>
          </div>
        )}
      </DropdownTrigger>

      <DropdownMenu
        aria-label={ariaLabel}
        className="text-xs text-gray-800 dark:text-gray-100 font-sans"
        classNames={{
          base: className || "min-w-[123px]",
        }}
      >
        {actions?.map((action) => {
          if (action?.show === false) return null;
          const key = action?.id || action?.key || action?.name || action?.label;
          const label = action?.name || action?.label || action?.text;
          const icon = action?.icon || action?.startContent;
          const isDanger = action?.color === "danger" || action?.isDanger;

          return (
            <DropdownItem
              key={key}
              textValue={label}
              onPress={() => {
                if (action?.onClick) action.onClick(itemId);
                else if (action?.onPress) action.onPress(itemId);
              }}
              className={
                action?.className ||
                (isDanger
                  ? "text-red-500 dark:text-red-400 data-[hover=true]:bg-red-50 dark:data-[hover=true]:bg-red-950/40 data-[hover=true]:text-red-600 dark:data-[hover=true]:text-red-300"
                  : "text-gray-800 dark:text-gray-100 data-[hover=true]:bg-gray-100 dark:data-[hover=true]:bg-gray-800 data-[hover=true]:text-gray-900 dark:data-[hover=true]:text-gray-100")
              }
            >
              <div className="flex gap-2 items-center text-xs">
                {icon}
                {label}
              </div>
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CommonDropdownMenu;
